/* Aloha Club kraskaart-pop-up (mysteryprijs), welcome flow v2
   ===========================================================
   De opvolger van aloha-welkomstcadeau.js voor de NL-test van oktober
   2026. Twee groepen: K ziet de kraskaart, H (holdout) ziet niets maar
   telt overal in mee. De trechter is krassen eerst, dan de
   onthulling, dan het e-mailadres, dan "check je inbox" (volgorde
   herzien op aanwijzing van Luuk, 2 oktober, tijdens de testronde:
   eerst winnen, dan pas iets geven); het cadeau komt per mail (lijst
   Wfxzj4), dus alle winkelwagen- en kortingslogica uit het oude script
   is hier met opzet weg.

   Wat ongewijzigd is overgenomen uit het oude script (en waarom het er
   staat, staat daar uitgebreider): het geheugen awc.v1, de meting met
   bezoeker/bezoek/sessie, de klantafscherming in drie lagen (Klaviyo
   isIdentified, ingelogde Shopify-klant, de blijvende ?awc=stil-vlag
   voor campagnelinks), de wegklik-rust van veertien dagen, het
   paginaslot tijdens het krassen en de groepsstempel op de
   winkelwagen. Dezelfde sleutels, zodat wie de oude pop-up al heeft
   weggeklikt of als klant is gemarkeerd dat hier ook is. */
(function () {
  'use strict';
  var wortel = document.getElementById('awc');
  if (!wortel || !wortel.classList.contains('awc-krasversie')) return;

  /* Direct kind van body, anders breekt een voorouder met transform de
     vaste positionering (Luuk zag dat 21 augustus op het testthema). */
  if (wortel.parentNode !== document.body) document.body.appendChild(wortel);

  var LIJST   = wortel.dataset.lijst;
  var SLEUTEL = wortel.dataset.sleutel;
  var TAAL    = wortel.dataset.taal;

  var OPSLAG   = 'awc.v1';
  var WACHT_MS = 8000;          // tonen na acht seconden
  var RUST_DAGEN = 14;          // na wegklikken zolang niet opnieuw tonen

  /* ---------------- opslag ---------------- */
  function lees() {
    try { return JSON.parse(localStorage.getItem(OPSLAG)) || {}; }
    catch (e) { return {}; }
  }
  function schrijf(o) {
    try { localStorage.setItem(OPSLAG, JSON.stringify(o)); } catch (e) {}
  }

  var staat = lees();

  /* Zonder werkende opslag zou elke pagina opnieuw loten; zo'n browser
     doet niet mee aan de meting, de pop-up zelf werkt gewoon. */
  var OPSLAG_OK = (function () {
    try {
      localStorage.setItem('awc.t', '1');
      localStorage.removeItem('awc.t');
      return true;
    } catch (e) { return false; }
  })();

  /* ---------------- proefschakelaar ----------------
       ?awc=nu   opnieuw beginnen, verdeling opnieuw geloot
       ?awc=k    dwingend de kraskaart
       ?awc=h    dwingend de holdout
     Alle drie wissen het geheugen en zetten de wachttijd op een
     seconde. ?awc=stil hieronder is geen proefschakelaar maar de
     klantmarkering voor campagnelinks. */
  var testmodus = !!staat.proef;
  var proef = /[?&]awc=(nu|k|h)(&|$)/i.exec(location.search);
  if (proef) {
    try { localStorage.removeItem(OPSLAG); } catch (e) {}
    staat = {};
    var gekozen = proef[1].toLowerCase();
    if (gekozen !== 'nu') staat.variant = gekozen.toUpperCase();
    /* De keuze moet paginawissels overleven: zonder deze vlag loot het
       herloot-script in de snippet de gedwongen variant op de volgende
       pagina weer weg. */
    staat.herloot_kras2 = true;
    /* Blijvend, met opzet: ook de pagina's na de proefpagina zijn van
       de tester. Alleen de meting slaat hem over. */
    staat.proef = true;
    schrijf(staat);
    WACHT_MS = 1000;
    testmodus = true;
  }

  /* ---------------- klantschakelaar ----------------
     ?awc=stil op campagnelinks markeert deze browser blijvend als
     klant: geen pop-up en geen plek in de meting. De vaste regel sinds
     het campagneweekend van 22-23 augustus, toen de permalink-omweg
     het Klaviyo-herkenningsteken sloopte en tientallen bestaande
     klanten zich via de pop-up inschreven. ?awc=nu wist dit weer. */
  if (!testmodus && /[?&]awc=stil(&|$)/i.test(location.search)) {
    staat.klant = true;
    schrijf(staat);
  }

  /* ---------------- loting ----------------
     Drie getallen uit de snippet (kras, ongebruikt, holdout). Sinds
     13 oktober 100,0,0: de steekproef is klaar, iedereen loot de
     kraskaart (besluit Luuk). De holdout-paden hieronder blijven
     staan voor als er ooit weer een steekproef draait. */
  var VERDELING = String(wortel.dataset.verdeling || '100,0,0')
                    .split(',').map(function (n) { return parseFloat(n) || 0; });
  if (!staat.variant) {
    var totaal = VERDELING[0] + VERDELING[1] + VERDELING[2];
    var worp = Math.random() * (totaal > 0 ? totaal : 100);
    staat.variant = worp < VERDELING[0] ? 'K' : 'H';
    schrijf(staat);
  }
  var VARIANT = staat.variant;
  /* Een variant uit de oude reeks (A, B of M) die het herloot-script om
     wat voor reden dan ook overleefde, hoort hier niet thuis: opnieuw. */
  if (VARIANT !== 'K' && VARIANT !== 'H') {
    VARIANT = staat.variant = Math.random() * 100 < VERDELING[0] ? 'K' : 'H';
    schrijf(staat);
  }
  var HOLDOUT = VARIANT === 'H';

  var alKlaar = !!staat.klaar;
  var pasWeggeklikt = staat.weg && (Date.now() - staat.weg) < RUST_DAGEN * 864e5;
  var bekendeKlant = !testmodus && !!staat.klant;
  var magTonen = !alKlaar && !HOLDOUT && !pasWeggeklikt && !bekendeKlant;
  /* De holdout en de wegklikker lopen in de meting gewoon mee, anders
     vergelijk je twee ongelijke groepen (zie het oude script). */
  var magMeten = !alKlaar && (magTonen || HOLDOUT || pasWeggeklikt) && !bekendeKlant && OPSLAG_OK;
  if (!magTonen && !magMeten && !alKlaar) return;

  /* ---------------- meten ---------------- */
  var METEN_PAGINA = Date.now();
  var METEN_GETELD = 0;
  var METEN_GETOOND = 0;
  var METEN_STAP = '';
  var METEN_AL = {};
  var SESSIE_GAT_MS = 30 * 60 * 1000;

  var APPARAAT = (window.innerWidth < 750 ||
                  (window.matchMedia && window.matchMedia('(pointer: coarse)').matches))
                 ? 'mobiel' : 'desktop';

  var NIEUW_BEZOEK = !staat.sessieLaatst ||
                     (METEN_PAGINA - staat.sessieLaatst) > SESSIE_GAT_MS;
  if (NIEUW_BEZOEK) {
    staat.bezoeken = (staat.bezoeken || 0) + 1;
    staat.sessieMs = 0;
  }
  staat.sessieLaatst = METEN_PAGINA;
  schrijf(staat);
  var BEZOEK_NR = staat.bezoeken || 1;

  function bezoekerId() {
    if (!staat.bezoeker) {
      staat.bezoeker = 'awc-' + Date.now().toString(36) + '-' +
                       Math.random().toString(36).slice(2, 10);
      schrijf(staat);
    }
    return staat.bezoeker;
  }

  function meld(naam, extra, eenmalig) {
    try {
      if (eenmalig) {
        if (METEN_AL[naam]) return;
        METEN_AL[naam] = true;
      }
      if (testmodus) return;
      if (bekendeKlant) return;
      if (!window.klaviyo || typeof window.klaviyo.push !== 'function') return;
      var o = {
        variant: VARIANT,
        holdout: HOLDOUT,
        taal: TAAL,
        land: wortel.dataset.land || '',
        bezoeker: bezoekerId(),
        apparaat: APPARAAT,
        bezoek_nr: BEZOEK_NR,
        pagina: location.pathname
      };
      if (extra) for (var k in extra) if (extra.hasOwnProperty(k)) o[k] = extra[k];
      window.klaviyo.push(['track', naam, o]);
    } catch (e) {}
  }

  function sessieBijwerken(paginaMs) {
    try {
      staat.sessieMs = (staat.sessieMs || 0) + paginaMs;
      staat.sessieLaatst = Date.now();
      schrijf(staat);
      return staat.sessieMs;
    } catch (e) { return paginaMs; }
  }

  function paginaAfsluiten() {
    try {
      var paginaMs = Date.now() - METEN_PAGINA;
      if (paginaMs < 250) return;
      var erbij = paginaMs - METEN_GETELD;
      METEN_GETELD = paginaMs;
      var totaal = erbij > 0 ? sessieBijwerken(erbij) : (staat.sessieMs || 0);
      meld('AWC pagina verlaten', {
        ms_op_pagina: paginaMs,
        sessie_ms: totaal,
        getoond: !!METEN_AL['AWC getoond'],
        gesloten: !!METEN_AL['AWC gesloten'],
        ingeschreven: !!staat.klaar
      }, true);
    } catch (e) {}
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') paginaAfsluiten();
  });
  window.addEventListener('pagehide', paginaAfsluiten);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      METEN_PAGINA = Date.now();
      METEN_GETELD = 0;
      delete METEN_AL['AWC pagina verlaten'];
    }
  });

  /* ---------------- welk product bekeek iemand ---------------- */
  function heroProduct() {
    var p = location.pathname;
    if (p.indexOf('scorpion') > -1) return 'scorpion';
    if (p.indexOf('pleasurefyer') > -1) return 'pleasurefyer';
    if (p.indexOf('satisfy') > -1) return 'satisfy';
    return '';
  }

  /* ---------------- schermen ---------------- */
  var scherm  = wortel.querySelector('.awc-scherm');
  var teaser  = wortel.querySelector('.awc-teaser');
  var stappen = {};
  wortel.querySelectorAll('.awc-stap').forEach(function (s) { stappen[s.dataset.stap] = s; });

  /* ---------------- de kaart krijgt de ruimte die overblijft ------- */
  var KAART_MIN = 108;
  var KAART_MAX = 300;
  var KAART_LUCHT = 14;

  /* Vanaf de onthulling staat de kaartmaat vast: de wissel naar de
     adresmodus mag de kaart geen pixel verplaatsen of schalen (Luuk,
     3-10). Alleen een echte maatwissel van het venster geeft de
     meting weer vrij. */
  var KAART_VAST = false;
  function kaartBevries() {
    var kaart = stappen['1k'] && stappen['1k'].querySelector('.awc-kaart');
    if (!kaart) return;
    var r = kaart.getBoundingClientRect();
    if (r.height > 0) {
      wortel.style.setProperty('--awc-kaarth', Math.round(r.height) + 'px');
      KAART_VAST = true;
    }
  }

  function kaartRuimte() {
    if (KAART_VAST) return;
    var stap = null;
    Object.keys(stappen).forEach(function (k) {
      if (!stappen[k].hidden) stap = stappen[k];
    });
    if (!stap) return;
    var kaart = stap.querySelector('.awc-kaart');
    if (!kaart) return;

    var logo = wortel.querySelector('.awc-logo');
    var ks = getComputedStyle(scherm);
    var ruimte = scherm.clientHeight
               - parseFloat(ks.paddingTop) - parseFloat(ks.paddingBottom);

    var stond = kaart.style.display;
    kaart.style.display = 'none';
    var gebruikt = stap.offsetHeight;
    if (logo) {
      gebruikt += logo.offsetHeight
                + parseFloat(getComputedStyle(logo).marginBottom || 0);
    }
    kaart.style.display = stond;

    var vrij = ruimte - gebruikt
             - parseFloat(getComputedStyle(kaart).marginTop || 0) - KAART_LUCHT;
    var vorm = parseFloat(wortel.dataset.kaartvorm || '1.6667');
    var opBreedte = stap.clientWidth / vorm;
    var hoog = Math.min(vrij, opBreedte, KAART_MAX);
    if (!(hoog > 0)) { wortel.style.removeProperty('--awc-kaarth'); return; }
    wortel.style.setProperty('--awc-kaarth', Math.max(KAART_MIN, Math.round(hoog)) + 'px');
  }

  function kaartVorm() {
    var kaart = wortel.querySelector('.awc-kaart');
    if (!kaart) return;
    var vorig = wortel.style.getPropertyValue('--awc-kaarth');
    wortel.style.removeProperty('--awc-kaarth');
    var r = kaart.getBoundingClientRect();
    if (r.height > 0) wortel.dataset.kaartvorm = String(r.width / r.height);
    if (vorig) wortel.style.setProperty('--awc-kaarth', vorig);
  }

  function meetOpnieuw() {
    kaartVorm();
    kaartRuimte();
    kaartRuimte();
    if (!onthuld) folieOpbouwen();
  }

  function toon(naam) {
    METEN_STAP = naam;
    Object.keys(stappen).forEach(function (k) { stappen[k].hidden = (k !== naam); });
    requestAnimationFrame(meetOpnieuw);
    if (naam === '3k') confetti();
  }

  /* Scherm 1 verandert ter plekke in het adresscherm: kop en subregel
     wisselen naar hun data-win-tekst, de Onthul-knop maakt plaats voor
     het e-mailveld en de kaart blijft exact staan. Een aparte stap gaf
     een zichtbare versprong van de onthulling (Luuk, 3-10). */
  var ADRESMODUS = false;
  function adresmodus() {
    if (ADRESMODUS) return;
    ADRESMODUS = true;
    var stap = stappen['1k'];
    stap.querySelectorAll('[data-win]').forEach(function (el) {
      el.textContent = el.dataset.win;
    });
    var knop1 = stap.querySelector('[data-onthul]');
    if (knop1) knop1.hidden = true;
    /* Bij een herbezoek na eerder krassen is er geen folie getekend;
       de kaart hoort dan meteen open te staan. Binnen de sessie
       staan deze klassen er al door de onthulling zelf. */
    var kaart = stap.querySelector('.awc-kaart-kras');
    if (kaart) {
      kaart.classList.add('awc-open', 'awc-folie-klaar');
      var folie = kaart.querySelector('.awc-folie');
      if (folie) folie.classList.add('awc-weg');
    }
    if (formulier) formulier.hidden = false;
    requestAnimationFrame(meetOpnieuw);
    setTimeout(function () {
      if (stappen['1k'].hidden) return;
      veld.focus({ preventScroll: true });
    }, 120);
  }

  /* Zolang de pop-up openstaat mag de pagina erachter niet meebewegen;
     anders breekt een veeg over de kaart af op scrollen (20 aug). */
  var scrollTop = 0, vorigeStijl = null;
  var VASTE_STIJL = ['position', 'top', 'left', 'right', 'width'];
  function paginaVast(vast) {
    var b = document.body, d = document.documentElement;
    if (vast) {
      if (vorigeStijl) return;
      vorigeStijl = {};
      VASTE_STIJL.forEach(function (n) { vorigeStijl[n] = b.style[n]; });
      vorigeStijl.gedrag = d.style.overscrollBehavior;
      scrollTop = window.pageYOffset || d.scrollTop || 0;
      b.style.position = 'fixed';
      b.style.top = '-' + scrollTop + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
      d.style.overscrollBehavior = 'none';
    } else {
      if (!vorigeStijl) return;
      VASTE_STIJL.forEach(function (n) { b.style[n] = vorigeStijl[n]; });
      d.style.overscrollBehavior = vorigeStijl.gedrag;
      vorigeStijl = null;
      window.scrollTo(0, scrollTop);
    }
  }

  function open() {
    METEN_GETOOND = Date.now();
    meld('AWC getoond', { na_ms: Date.now() - METEN_PAGINA }, true);
    wortel.hidden = false;
    wortel.classList.remove('awc-dicht');
    teaser.hidden = true;
    paginaVast(true);
    toon(staat.klaar ? '3k' : '1k');
    if (!staat.klaar && onthuld) adresmodus();
  }
  function dicht() {
    meld('AWC gesloten', {
      ms_zichtbaar: METEN_GETOOND ? (Date.now() - METEN_GETOOND) : null,
      stap: METEN_STAP,
      ingeschreven: !!staat.klaar
    }, true);
    wortel.classList.add('awc-dicht');
    wortel.classList.remove('awc-krast');
    teaser.hidden = false;
    paginaVast(false);
    staat.weg = Date.now();
    schrijf(staat);
  }

  wortel.querySelector('.awc-sluit').addEventListener('click', dicht);
  var shopKnop = wortel.querySelector('.awc-shop');
  if (shopKnop) shopKnop.addEventListener('click', dicht);
  teaser.addEventListener('click', function () {
    /* Wie al is ingeschreven krijgt het inbox-scherm terug, wie al
       kraste het adresscherm; wie nog bezig was begint waar hij was,
       of op een verse pagina gewoon vooraan. */
    if (staat.klaar) toon('3k');
    else {
      var openStap = false;
      Object.keys(stappen).forEach(function (k) { if (!stappen[k].hidden) openStap = true; });
      if (!openStap) toon('1k');
      if (onthuld) adresmodus();
    }
    wortel.classList.remove('awc-dicht');
    teaser.hidden = true;
    paginaVast(true);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !wortel.hidden && !wortel.classList.contains('awc-dicht')) dicht();
  });

  /* ---------------- confetti ---------------- */
  var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function confetti() {
    if (rustig) return;
    var doek = wortel.querySelector('.awc-confetti');
    if (!doek || !doek.getContext) return;
    var c = doek.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var b = window.innerWidth, h = window.innerHeight;
    doek.width = Math.round(b * dpr); doek.height = Math.round(h * dpr);
    doek.style.width = b + 'px'; doek.style.height = h + 'px';
    c.scale(dpr, dpr);

    var kleuren = ['#C6110F', '#8F0B0A', '#A87F33', '#D6B96A', '#FFFFFF', '#140B0B'];
    var snippers = [];
    for (var i = 0; i < 110; i++) {
      snippers.push({
        x: b * (0.2 + Math.random() * 0.6),
        y: h * 0.42 + (Math.random() * 40 - 20),
        vx: (Math.random() - 0.5) * 9,
        vy: -(6 + Math.random() * 9),
        br: 5 + Math.random() * 6,
        ho: 8 + Math.random() * 8,
        draai: Math.random() * Math.PI,
        dv: (Math.random() - 0.5) * 0.3,
        kleur: kleuren[i % kleuren.length]
      });
    }

    var begin = null;
    function stap(tijd) {
      if (begin === null) begin = tijd;
      var verstreken = tijd - begin;
      c.clearRect(0, 0, b, h);
      var levend = 0;
      for (var j = 0; j < snippers.length; j++) {
        var s = snippers[j];
        s.vy += 0.34;
        s.vx *= 0.995;
        s.x += s.vx; s.y += s.vy; s.draai += s.dv;
        if (s.y - s.ho > h) continue;
        levend++;
        c.save();
        c.translate(s.x, s.y);
        c.rotate(s.draai);
        c.globalAlpha = Math.max(0, 1 - verstreken / 2600);
        c.fillStyle = s.kleur;
        c.fillRect(-s.br / 2, -s.ho / 2, s.br, s.ho);
        c.restore();
      }
      if (levend && verstreken < 2600) requestAnimationFrame(stap);
      else c.clearRect(0, 0, b, h);
    }
    requestAnimationFrame(stap);
  }

  /* ---------------- kraskaart ----------------
     Zelfde folie en drempel als de goedgekeurde kaart (0.42 sinds
     20 aug: krassen is deel van de beleving). Krassen is stap 1 en
     kan meteen; het adres komt pas na de onthulling (Luuk, 2-10). */
  var DREMPEL = 0.42;
  var canvas, ctx, bezig = false, vorig = null, tel = 0;
  var onthuld = !!staat.onthuld;
  var krasDeel = 0;

  function actieveKrasstap() {
    if (stappen['1k'] && !stappen['1k'].hidden) return stappen['1k'];
    return null;
  }
  function magKrassen() {
    return !onthuld && !!(stappen['1k'] && !stappen['1k'].hidden);
  }

  function folieOpbouwen() {
    var stap = actieveKrasstap();
    if (!stap || onthuld) return;
    canvas = stap.querySelector('.awc-folie');
    if (!canvas) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var r = canvas.getBoundingClientRect();
    if (!r.width) {
      if (wortel.hidden || wortel.classList.contains('awc-dicht')) return;
      requestAnimationFrame(folieOpbouwen); return;
    }
    var breed = Math.round(r.width * dpr), hoog = Math.round(r.height * dpr);
    /* Is er op dit canvas al gekrast, dan blijft hij staan: een resize
       (iOS-adresbalk) mag het werk van de bezoeker niet uitwissen. */
    if (ctx && ctx.canvas === canvas && tel > 0) return;
    canvas.width = breed;
    canvas.height = hoog;
    canvas.dataset.dpr = dpr;
    ctx = canvas.getContext('2d');
    var w = canvas.width, h = canvas.height;
    ctx.globalCompositeOperation = 'source-over';

    // Hoogglans zwarte folie, Black Friday-editie (variant B, besluit
    // Luuk 23-10): zelfde opbouw als de goedgekeurde goudfolie, alleen
    // het palet is zwart met koele lichtaccenten. De glim komt uit de
    // CSS (::before) en loopt over dit canvas heen.
    var pal = ['#050507', '#1A1A20', '#3C3C46', '#26262E', '#0E0E12', '#000000'];
    var g = ctx.createLinearGradient(0, 0, w, h * 0.9);
    g.addColorStop(0, pal[0]); g.addColorStop(0.20, pal[1]); g.addColorStop(0.42, pal[2]);
    g.addColorStop(0.52, pal[3]); g.addColorStop(0.75, pal[4]); g.addColorStop(1, pal[5]);
    ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);

    for (var i = 0; i < 900; i++) {
      ctx.fillStyle = 'rgba(' + (i % 2 ? '235,235,245' : '0,0,0') + ',' + (0.03 + Math.random() * 0.07) + ')';
      ctx.fillRect(Math.random() * w, Math.random() * h, 1.6 * dpr, 1.6 * dpr);
    }

    ctx.save();
    ctx.translate(w / 2, h / 2); ctx.rotate(-0.42);
    for (var s = 0; s < 64; s++) {
      ctx.fillStyle = (s % 2 === 0)
        ? 'rgba(255,255,255,' + (0.012 + Math.random() * 0.028) + ')'
        : 'rgba(0,0,0,' + (0.03 + Math.random() * 0.05) + ')';
      ctx.fillRect(-w, -h + Math.random() * h * 2, w * 2, (0.6 + Math.random() * 1.6) * dpr);
    }
    for (var b = 0; b < 5; b++) {
      ctx.fillStyle = 'rgba(255,255,255,' + (0.02 + 0.012 * b) + ')';
      ctx.fillRect(-w, -h + Math.random() * h * 2, w * 2, (7 + Math.random() * 13) * dpr);
    }
    ctx.restore();

    var kern = ctx.createRadialGradient(w * 0.5, h * 0.42, 0, w * 0.5, h * 0.42, w * 0.55);
    kern.addColorStop(0, 'rgba(255,255,255,.14)'); kern.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = kern; ctx.fillRect(0, 0, w, h);

    var rad = 16 * dpr;
    if (ctx.roundRect) {
      ctx.lineWidth = 2 * dpr; ctx.strokeStyle = 'rgba(0,0,0,.65)';
      ctx.beginPath(); ctx.roundRect(1.5 * dpr, 1.5 * dpr, w - 3 * dpr, h - 3 * dpr, rad); ctx.stroke();
      ctx.strokeStyle = 'rgba(255,255,255,.26)';
      ctx.beginPath(); ctx.roundRect(4.5 * dpr, 4.5 * dpr, w - 9 * dpr, h - 9 * dpr, rad * 0.8); ctx.stroke();
    }

    ctx.fillStyle = 'rgba(255,255,255,.9)';
    ctx.font = 'bold ' + Math.max(18 * dpr, w * 0.058) + 'px ' + getComputedStyle(wortel).fontFamily;
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.shadowColor = 'rgba(0,0,0,.6)'; ctx.shadowBlur = 4 * dpr;
    ctx.fillText(wortel.dataset.krashint || '', w / 2, h / 2);
    ctx.shadowBlur = 0;

    canvas.parentNode.classList.add('awc-folie-klaar');
  }

  function positie(e) {
    var r = canvas.getBoundingClientRect();
    return { x: (e.clientX - r.left) * (canvas.width / r.width),
             y: (e.clientY - r.top) * (canvas.height / r.height) };
  }
  function kras(e) {
    if (!bezig || onthuld || !ctx) return;
    var p = positie(e);
    var straal = canvas.width * 0.085;
    ctx.globalCompositeOperation = 'destination-out';
    ctx.beginPath(); ctx.arc(p.x, p.y, straal, 0, Math.PI * 2); ctx.fill();
    if (vorig) {
      ctx.lineWidth = straal * 2; ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(vorig.x, vorig.y); ctx.lineTo(p.x, p.y); ctx.stroke();
    }
    vorig = p;
    if (++tel % 6 === 0) meet();
    if (e.cancelable) e.preventDefault();
  }
  function meet() {
    if (onthuld || !ctx) return;
    try {
      var d = ctx.getImageData(0, 0, canvas.width, canvas.height).data, leeg = 0, totaal = 0;
      for (var i = 3; i < d.length; i += 128) { totaal++; if (d[i] === 0) leeg++; }
      krasDeel = leeg / totaal;
      var kaart = canvas.closest('.awc-kaart-kras');
      if (kaart) kaart.style.setProperty('--awc-onthuld', String(krasDeel));
      if (krasDeel > DREMPEL) onthul();
    } catch (err) {}
  }
  function onthul() {
    if (onthuld) return;
    onthuld = true;
    kaartBevries();
    if (canvas) canvas.classList.add('awc-weg');
    var kaart = stappen['1k'].querySelector('.awc-kaart-kras');
    if (kaart) kaart.classList.add('awc-open');
    /* De onthulling overleeft paginawissels: wie wegklikt of
       doorklikt begint de volgende keer bij het adresscherm, niet
       opnieuw bij een dichte kaart. */
    staat.onthuld = true;
    schrijf(staat);
    meld('AWC onthuld', {
      ms_zichtbaar: METEN_GETOOND ? (Date.now() - METEN_GETOOND) : null
    }, true);
    confetti();
    // Even laten landen wat er staat, dan het adresveld erbij: zelfde
    // scherm, zelfde kaart, niets verspringt.
    setTimeout(function () {
      if (!stappen['1k'].hidden) adresmodus();
    }, 1400);
  }

  /* De zichtbare Onthul-knop in de krasstap onthult direct, ook als
     er nog niet genoeg is gekrast (feedback Luuk, 24-10, op de
     v40-preview; vervangt de schudhint uit de simulatie van 29
     september). Krassen blijft de beleving, de knop is de zekere
     uitweg: niemand staat ooit voor een dichte deur. */
  var onthulKnop = wortel.querySelector('[data-onthul]');
  if (onthulKnop) {
    onthulKnop.addEventListener('click', function () {
      if (onthuld) { adresmodus(); return; }
      onthul();
    });
  }

  function opKaart(doel) {
    return doel && doel.closest ? doel.closest('.awc-kaart-kras') : null;
  }

  function beginKrassen(kaart) {
    var folie = kaart.querySelector('.awc-folie');
    if (!folie) return false;
    canvas = folie;
    if (!ctx || !canvas.width) { onthul(); return false; }
    bezig = true; vorig = null;
    wortel.classList.add('awc-krast');
    return true;
  }

  function stopKrassen() {
    if (!bezig) return;
    bezig = false; vorig = null;
    wortel.classList.remove('awc-krast');
    meet();
  }

  wortel.addEventListener('pointerdown', function (e) {
    if (!magKrassen()) return;
    var kaart = opKaart(e.target);
    if (!kaart || onthuld) return;
    if (!beginKrassen(kaart)) return;
    try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
    kras(e);
    if (e.cancelable) e.preventDefault();
  }, { passive: false });
  wortel.addEventListener('pointermove', kras, { passive: false });
  ['pointerup', 'pointercancel'].forEach(function (t) {
    wortel.addEventListener(t, stopKrassen);
  });

  wortel.addEventListener('touchstart', function (e) {
    if (!magKrassen() || onthuld || !opKaart(e.target)) return;
    if (e.cancelable) e.preventDefault();
  }, { passive: false });
  wortel.addEventListener('touchmove', function (e) {
    if (!bezig) return;
    if (e.cancelable) e.preventDefault();
  }, { passive: false });
  ['touchend', 'touchcancel'].forEach(function (t) {
    wortel.addEventListener(t, stopKrassen);
  });

  var meetWacht = null;
  function bijMaatwissel() {
    KAART_VAST = false;
    if (meetWacht) clearTimeout(meetWacht);
    meetWacht = setTimeout(function () { requestAnimationFrame(meetOpnieuw); }, 120);
  }
  window.addEventListener('resize', bijMaatwissel);
  window.addEventListener('orientationchange', bijMaatwissel);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { requestAnimationFrame(meetOpnieuw); });
  }
  if (window.ResizeObserver) {
    var kijker = new ResizeObserver(bijMaatwissel);
    wortel.querySelectorAll('.awc-kop,.awc-sub,.awc-micro')
          .forEach(function (el) { kijker.observe(el); });
  }

  /* ---------------- inschrijven bij Klaviyo ----------------
     Bij het versturen van het adres, na de onthulling: de mail gaat
     weg op het moment van de submit, dus "zojuist gestuurd" op het
     slotscherm klopt letterlijk. */
  var formulier = stappen['1k'].querySelector('.awc-rij');
  var veld      = stappen['1k'].querySelector('.awc-veld');
  var knop      = stappen['1k'].querySelector('.awc-verstuur');
  var fout      = stappen['1k'].querySelector('.awc-fout');

  function adresTonen(adres) {
    var vak = stappen['3k'].querySelector('.awc-adres');
    if (vak) vak.textContent = adres || wortel.dataset.inboxwoord || 'je inbox';
  }
  adresTonen(staat.adres || '');

  /* Het startschot voor de mails. De flow hangt aan dit event in
     plaats van aan de lijst, omdat Klaviyo events vrijwel direct
     verwerkt en nieuwe lijstleden pas na enkele minuten oppakt
     (besluit Luuk, 3-10: de mail moet er per direct zijn).

     Het event gaat pas weg nadat de inschrijving door Klaviyo is
     bevestigd, met drie seconden marge zodat de toestemming verwerkt
     is voordat het consent-filter van de flow ernaar kijkt. Mislukt
     het verzoek, dan volgen twee herkansingen; keepalive laat de
     laatste poging ook afmaken als de bezoeker net wegklikt. */
  function startschot(adres, poging) {
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + SLEUTEL, {
        method: 'POST',
        keepalive: true,
        headers: { 'content-type': 'application/json', 'revision': '2025-01-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: {
                WelkomVariant: VARIANT,
                WelkomTaal: TAAL,
                WelkomLand: wortel.dataset.land || '',
                WelkomPagina: location.pathname
              },
              metric: { data: { type: 'metric', attributes: { name: 'Kraskaart ingeschreven' } } },
              profile: { data: { type: 'profile', attributes: { email: adres } } }
            }
          }
        })
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
      }).catch(function () {
        if (poging < 2) setTimeout(function () { startschot(adres, poging + 1); }, 4000);
      });
    } catch (e) {}
  }

  formulier.addEventListener('submit', function (e) {
    e.preventDefault();
    var adres = veld.value.trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(adres)) { veld.focus(); return; }
    knop.disabled = true;
    fout.hidden = true;

    // Proefstand voor de previews: geen echt verzoek, wel de doorloop.
    if (wortel.dataset.proef) {
      setTimeout(function () {
        staat.klaar = true; staat.adres = adres; schrijf(staat);
        adresTonen(adres);
        toon('3k');
      }, 350);
      return;
    }

    var eigenschappen = {
      WelkomVariant: VARIANT,
      WelkomHeroProduct: heroProduct(),
      WelkomTaal: TAAL,
      WelkomLand: wortel.dataset.land || '',
      WelkomUur: new Date().getHours(),
      WelkomPagina: location.pathname
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + SLEUTEL, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2025-01-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Kraskaart pop-up',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: adres,
                  properties: eigenschappen
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: LIJST } } }
        }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      staat.klaar = Date.now();
      /* Alleen in deze browser, voor het slotscherm bij een volgend
         bezoek; het adres gaat verder nergens heen. */
      staat.adres = adres;
      schrijf(staat);
      adresTonen(adres);
      meld('AWC ingeschreven', {
        ms_zichtbaar: METEN_GETOOND ? (Date.now() - METEN_GETOOND) : null,
        ms_op_pagina: Date.now() - METEN_PAGINA
      }, true);
      setTimeout(function () { startschot(adres, 0); }, 3000);
      toon('3k');
    }).catch(function () {
      knop.disabled = false;
      fout.hidden = false;
      fout.textContent = wortel.dataset.foutmelding || 'Dat lukte niet. Probeer het nog een keer.';
    });
  });

  /* ---------------- klantafscherming, laag 1 en 2 ----------------
     Laag 1: Klaviyo kent deze browser al als profiel (isIdentified,
     zes seconden geduld, bij twijfel tonen). Zes in plaats van de
     eerdere anderhalf (3-10): op mobiel was klaviyo.js nog niet klaar
     binnen anderhalve seconde en glipte een bestaande klant erdoor;
     de pop-up wacht toch al acht seconden, dus dit geduld is gratis.
     Laag 2: ingelogde Shopify-klant. Laag 3 is de blijvende
     ?awc=stil-vlag hierboven. De proefschakelaar slaat de lagen over,
     anders valt er vanaf een bekende browser nooit meer iets te
     testen. */
  function bekendBijKlaviyo() {
    /* Niet één keer vragen maar blijven proberen binnen het venster:
       als klaviyo.js nog niet geladen is, gaf één vraag vooraf direct
       "onbekend" terug en was al het geduld voor niets. */
    return new Promise(function (klaar) {
      var tot = Date.now() + 6000;
      setTimeout(function () { klaar(false); }, 6000);
      function probeer() {
        try {
          if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
            Promise.resolve(window.klaviyo.isIdentified())
              .then(function (ja) { klaar(!!ja); })
              .catch(function () { klaar(false); });
            return;
          }
        } catch (e) {}
        if (Date.now() < tot) setTimeout(probeer, 400);
        else klaar(false);
      }
      probeer();
    });
  }

  function ingelogdeKlant() {
    try {
      var p = window.ShopifyAnalytics
           && window.ShopifyAnalytics.meta
           && window.ShopifyAnalytics.meta.page;
      if (p && p.customerId) return true;
    } catch (e) {}
    try {
      if (window.__st && window.__st.cid) return true;
    } catch (e) {}
    return false;
  }

  /* ---------------- de groep vastleggen ----------------
     De holdout schrijft zich nooit in; zonder stempel op de
     winkelwagen is die groep onzichtbaar en valt er niets te
     vergelijken. Eén keer per bezoek, zelfde sleutels als altijd,
     zodat de bestelrapportage gewoon doorloopt. */
  function groepVastleggen() {
    if (testmodus) return;
    if (staat.groepBezoek === staat.bezoeken) return;
    if (typeof fetch !== 'function') return;
    staat.groepBezoek = staat.bezoeken;
    schrijf(staat);
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'content-type': 'application/json', 'x-awc': '1' },
      body: JSON.stringify({ attributes: {
        'awc-groep': VARIANT,
        'awc-taal': TAAL,
        'awc-land': wortel.dataset.land || '',
        'awc-bezoeker': bezoekerId()
      } })
    }).catch(function () {
      staat.groepBezoek = null;
      schrijf(staat);
    });
  }

  /* ---------------- tonen ---------------- */
  if (magMeten) {
    var poort = testmodus ? Promise.resolve(false) : bekendBijKlaviyo();
    var wachttijd = new Promise(function (klaar) { setTimeout(klaar, WACHT_MS); });
    Promise.all([poort, wachttijd]).then(function (uitslag) {
      if (uitslag[0]) return;                          // laag 1: Klaviyo kent de browser
      if (!testmodus && ingelogdeKlant()) return;      // laag 2: ingelogde Shopify-klant
      /* Pas na beide poorten vastleggen en tellen, zodat elke groep
         dezelfde soort bezoekers bevat: geen bestaande klanten, in
         geen enkele groep. */
      groepVastleggen();
      meld('AWC bezoek', { toonbaar: magTonen }, true);
      if (magTonen) open();
      else if (pasWeggeklikt && !HOLDOUT) {
        wortel.hidden = false;
        wortel.classList.add('awc-dicht');
        teaser.hidden = false;
      }
    });
  }
  else if (alKlaar) {
    /* De afronder telt mee in noemer en sessieduur en zijn wagen krijgt
       per bezoek een vers etiket. Het knopje blijft staan zodat het
       inbox-scherm altijd terug te vinden is. */
    groepVastleggen();
    meld('AWC bezoek', { toonbaar: false }, true);
    wortel.hidden = false;
    wortel.classList.add('awc-dicht');
    teaser.hidden = false;
  }
})();
